<template>
    <transition
        name="right-slide"
        mode="out-in"
    >
        <section
            v-if="visibility"
            :class="['popup', {'popup--desktop': !$isMobileOrTablet}]"
        >
            <UIButton
                v-if="!temporary"
                flat
                class="popup__close"
                aria-label="Закрытие попапа с информацией"
                @click="$emit('hide')"
            >
                <template #icon>
                    <CloseSvg />
                </template>
            </UIButton>
            <slot />
        </section>
    </transition>
</template>

<script>
import {defineComponent} from 'vue';

import {UIButton} from '@cibsite/ui-components-vue2';
import CloseSvg from '@/assets/images/icons/close.svg?inline';

export default defineComponent({
    name: 'PopupComponent',
    components: {
        CloseSvg,
        UIButton,
    },
    props: {
        visibility: {
            type: Boolean,
            default: () => false,
        },
        temporary: {
            type: Boolean,
            default: () => false,
        },
    },
});
</script>

<style lang="scss" scoped>
.popup {
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 999;
    max-width: 716px;
    max-height: 278px;
    padding: 32px;
    background-color: var(--color-primary-70);
    border-radius: 12px;
    box-shadow: $shadow4;

    &--desktop {
        bottom: 50%;
        transform: translateY(50%);
    }

    @media (width <= 600px) {
        bottom: 24px;
        right: 50%;
        transform: translateX(50%);
        padding: 24px;
        width: 100%;
    }

    &__close {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 10;

        .ui-button__icon svg {
            width: 15px;
        }
    }
}
</style>
